import React, { useState } from "react";
import AdminLayout from "../AdminLayout";
import "../AdminForm.css";
import BalanceSheetReport from "./BalanceSheetReport";
import LedgerStatementReport from "./LedgerStatementReport";
import TradingPlReport from "./TradingPlReport";
import InvoiceReport from "./InvoiceReport";

const SECTIONS = [
  { key: "balance-sheet", label: "Balance Sheet" },
  { key: "ledger", label: "Ledger / Statement of Account" },
  { key: "trading-pl", label: "Trading & Profit and Loss Account" },
  { key: "invoice", label: "Sales Invoice" },
];

export default function ReportsHome() {
  const [active, setActive] = useState("balance-sheet");

  return (
    <AdminLayout>
      <div className="page-header">
        <h1 className="page-title">Reports</h1>
      </div>

      <div className="content-card">
        <div className="tab-container">
          {SECTIONS.map((s) => (
            <button
              key={s.key}
              className={`tab-btn ${active === s.key ? "active" : ""}`}
              onClick={() => setActive(s.key)}
            >
              {s.label}
            </button>
          ))}
        </div>

        <div className="form-wrapper">
          {active === "balance-sheet" && <BalanceSheetReport />}
          {active === "ledger" && <LedgerStatementReport />}
          {active === "trading-pl" && <TradingPlReport />}
          {active === "invoice" && <InvoiceReport />}
        </div>
      </div>
    </AdminLayout>
  );
}